import { connect } from 'react-redux';
import { ConversionReport } from './ConversionReport';
import { conversionRateSelector } from '../../redux/selectors/conversionSelector';

const mapStateToProps = conversionRateSelector;

export const ConnectedConversionReport = connect(mapStateToProps)(ConversionReport);
